// AppRoute.js

import { AUTH_PERMISSIONS } from "constants/AuthConstant";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { onBlankLayout } from "store/slices/themeSlice";

const AppRoute = ({
  component: Component,
  routeKey,
  blankLayout,
  access = [], // Dapatkan properti 'access' yang berisi izin yang dibutuhkan
  ...props
}) => {
  const dispatch = useDispatch();
  const permissions = JSON.parse(localStorage.getItem(AUTH_PERMISSIONS));

  // Cek apakah pengguna memiliki izin yang dibutuhkan
  // const hasPermission = access.every((permission) =>
  //   permissions.includes(permission),
  // );

  const hasPermission =
    access?.length > 0
      ? access.some((data) => permissions.includes(data))
      : true;

  useEffect(() => {
    const isBlank = blankLayout ? true : false;
    dispatch(onBlankLayout(isBlank));
  }, [dispatch, blankLayout]);

  // Jika pengguna tidak memiliki izin, alihkan ke halaman "Access Denied"
  // if (!hasPermission) {
  //   return <Navigate to="/access-denied" />;
  // }

  // Render komponen jika pengguna memiliki izin
  return <Component {...props} />;
};

export default AppRoute;
